import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Layout from './components/layout/Layout';
import Login from './screens/auth/Login';
import UserManagement from './screens/users/UserManagement';
import Profile from './screens/profile/Profile';
import { ChangePassword } from './screens/profile/ChangePassword';
import { Dashboard } from './screens/dashboard/Dashboard';
import ContainerList from './screens/container/ContainerList';
import ContainerDetail from './screens/container/ContainerDetail';
import { AddContainer } from './screens/container/AddContainer';
import Settings from './screens/settings/Settings';
import ProtectedRoute from './components/auth/ProtectedRoute';
import OrderManagement from './screens/orders/OrderManagement';
import OrderDetail from './screens/orders/OrderDetail';
import NotificationList from './screens/notifications/NotificationList';
import MySales from './screens/sales/MySales';
import MyPurchases from './screens/purchases/MyPurchases';
import './i18n';
import { LoadScript } from "@react-google-maps/api";
import PaymentTransactions from './screens/payments/PaymentTransactions';
import { PaymentDetails } from './screens/payments/PaymentDetails';

const App: React.FC = () => {

  const googleApiKey: string = process.env.REACT_APP_GOOGLE_MAP_API_KEY || "";


  return (
    <AuthProvider>
      <NotificationProvider>

        <LoadScript googleMapsApiKey={ googleApiKey } libraries={ [ 'places' ] }>
          <Router>
            <Routes>

              <Route path="/login" element={ <Login /> } />

              <Route path="/" element={ <ProtectedRoute><Layout /></ProtectedRoute> }>

                <Route index element={ <Dashboard /> } />
                <Route path="users" element={ <UserManagement /> } />

                <Route path="lockers">
                  <Route index element={ <ContainerList /> } />
                  <Route path="add" element={ <AddContainer /> } />
                  <Route path=":id" element={ <ContainerDetail /> } />
                  <Route path=":id/view" element={ <ContainerDetail viewOnly /> } />
                </Route>

                <Route path="orders">
                  <Route index element={ <OrderManagement /> } />
                  <Route path=":id" element={ <OrderDetail /> } />
                  <Route path=":id/view" element={ <OrderDetail viewOnly /> } />
                </Route>

                <Route path="notifications" element={ <NotificationList /> } />
                <Route path="payment-history" element={ <PaymentTransactions /> } />
                <Route path="payment-history/:id" element={ <PaymentDetails /> } />

                <Route path="settings" element={ <Settings /> } />
                <Route path="profile" element={ <Profile /> } />
                <Route path="change-password" element={ <ChangePassword /> } />
                <Route path="sales" element={ <MySales /> } />
                <Route path="purchases" element={ <MyPurchases /> } />

              </Route>

              <Route path="*" element={ <Navigate to="/dashboard" replace /> } />

            </Routes>
          </Router>
        </LoadScript>

      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;
